import AppConstants from '../../Constants/AppConstants';

const storageKey = () => `arcticwhale:${AppConstants.tenantName || 'current-tenant'}:${AppConstants.userId || 'current-user'}:delivery:shipping-config`;
export const readShippingConfigDraft = () => {
  try {
    const draft = JSON.parse(window.localStorage.getItem(storageKey()) || '{}');
    return draft && typeof draft === 'object' ? draft : {};
  } catch (error) { return {}; }
};
export const writeShippingConfigDraft = configs => {
  const draft = {};
  ['flat_shipping_fee', 'schedule_time', 'fulfillment_by_platform_enabled'].forEach(key => {
    const value = configs?.[key]?.value;
    if (typeof value === 'boolean' || typeof value === 'string' || typeof value === 'number') draft[key] = value;
  });
  try { window.localStorage.setItem(storageKey(), JSON.stringify(draft)); }
  catch (error) { /* Keep settings usable if browser storage is unavailable. */ }
};
export const clearShippingConfigDraft = () => {
  try { window.localStorage.removeItem(storageKey()); }
  catch (error) { /* Ignore storage errors after a successful save. */ }
};
